import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";
import LoadingImage from "./Loading";

const whatWeCards = [
  {
    heading: (
      <Box
        sx={{
          fontWeight: 600,
          fontSize: "22px",
        }}
      >
        Lazy Work
      </Box>
    ),
    subText:
      "We are hard working and passionate professionals that understand the value of setting standards and making an impact that will eventually change lives.",
    backgroundColor: "primary.main",
    borderTop: "8px solid black",
    numColor: "white",
    headingColor: "white",
    subTextColor: "white",
  },
  {
    heading: (
      <Box
        sx={{
          fontWeight: 600,
          fontSize: "22px",
        }}
      >
        Unpaid Work
      </Box>
    ),
    subText:
      "Free work is not good business for anyone. We believe that the most professional, valuable and effective work is built on the foundation of close collaboration, reciprocal partnership and deep understanding.",
    backgroundColor: "black",
    borderTop: "8px solid #1E9FD4",
    numColor: "white",
    headingColor: "white",
    subTextColor: "white",
  },
  {
    num: "Three",
    heading: (
      <Box
        sx={{
          fontWeight: 600,
          fontSize: "22px",
        }}
      >
        Limit Creativity
      </Box>
    ),
    subText:
      "We let employees share ideas and grow additional skills that makes them .....",
    backgroundColor: "#EDEDED",
    borderTop: "8px solid black",
    numColor: "#262525",
    headingColor: "primary.main",
    subTextColor: "#262525",
  },
];

export default function About() {
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(false);

  const getTeam = async () => {
    setLoading(true);

    try {
      const { data } = await axios.get(
        `${
          process.env.REACT_APP_PROD_MODE === "test"
            ? process.env.REACT_APP_API_URL_TEST
            : process.env.REACT_APP_API_URL_LIVE
        }/admin/all-members`
      );

      setTeam(data.team);
    } catch (error) {}
    setLoading(false);
  };

  useEffect(() => {
    getTeam();
  }, []);

  return (
    <Container
      sx={{
        paddingTop: { xs: "100px", md: "120px" },
      }}
      maxWidth="lg"
    >
      <Box
        sx={{
          minHeight: "100vh",
          py: 8,
          background: "linear-gradient(135deg, #f0f4ff 0%, #e5ecf9 100%)",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Container maxWidth="md">
          {/* Header Section */}
          <Box textAlign="center" mb={6}>
            <Typography
              variant="h3"
              fontWeight={700}
              color="primary"
              gutterBottom
            >
              About IONEC
            </Typography>
            <Typography variant="h5" fontWeight={500} color="text.secondary">
              Driving Innovation, Delivering Disruption
            </Typography>
          </Box>

          {/* Introduction */}
          <Card
            elevation={4}
            sx={{
              borderRadius: 4,
              mb: 6,
              p: 3,
              backgroundColor: "#ffffffcc",
              backdropFilter: "blur(8px)",
            }}
          >
            <CardContent>
              <Typography variant="body1" sx={{ mb: 2 }}>
                At <strong>IONEC</strong>, we don’t just embrace the future of
                business — we engineer it. We are a dedicated Information
                Technology company specializing in innovative technology
                solutions designed to empower your business to achieve true
                market disruption and unprecedented efficiency.
              </Typography>

              <Divider sx={{ my: 2 }} />

              <Typography
                variant="h5"
                fontWeight={600}
                color="primary"
                gutterBottom
              >
                Our Mission: Transform. Automate. Lead.
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                In today’s fast-paced digital landscape, standing still is not
                an option. Our mission is to transform how you operate, enabling
                you to lead your market instead of simply competing in it.
              </Typography>

              <Typography variant="body1">
                When you come to us looking for ways to make your business
                better, faster, and smarter, we offer a partnership rooted in
                novel and strategic automation. We analyze your core challenges
                and craft end-to-end digital strategies designed to:
              </Typography>

              <Box sx={{ mt: 2, ml: 2 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  • <strong>Disrupt the Status Quo:</strong> Introduce
                  innovative processes that make your competitors irrelevant.
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  • <strong>Achieve Operational Excellence:</strong> Automate
                  complex business processes for peak efficiency and accuracy.
                </Typography>
                <Typography variant="body2">
                  • <strong>Unlock New Revenue Streams:</strong> Leverage
                  digital channels and platforms to scale your growth.
                </Typography>
              </Box>
            </CardContent>
          </Card>

          {/* Core Solutions */}
          <Box mb={6} textAlign="center">
            <Typography
              variant="h4"
              fontWeight={700}
              color="primary"
              gutterBottom
            >
              Our Core Solutions
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={4}>
              We leverage a powerful toolkit of digital expertise to deliver
              measurable results:
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {[
              {
                title: "Business Process Automation",
                desc: "Designing and implementing novel ways to automate your core business processes, turning manual tasks into streamlined, digital workflows.",
              },
              {
                title: "Digital Consultation & Strategy",
                desc: "Providing expert guidance to define your digital roadmap and pinpoint areas for maximum market disruption.",
              },
              {
                title: "Custom Platforms & Solutions",
                desc: "Developing bespoke digital platforms that serve as the backbone for your operations and customer engagement.",
              },
              {
                title: "E-commerce & Digital Media",
                desc: "Building robust e-commerce solutions and crafting digital media strategies that amplify your brand and drive sales.",
              },
              {
                title: "Payment Gateways & Financial Tools",
                desc: "Integrating secure, seamless payment solutions that enhance the customer experience and improve cash flow.",
              },
            ].map((item, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Card
                  elevation={3}
                  sx={{
                    borderRadius: 3,
                    height: "100%",
                    transition: "0.3s",
                    "&:hover": { transform: "translateY(-5px)", boxShadow: 6 },
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="h6"
                      fontWeight={600}
                      color="primary"
                      gutterBottom
                    >
                      {item.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.desc}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Partnership Section */}
          <Card
            elevation={5}
            sx={{
              borderRadius: 4,
              mt: 8,
              p: 4,
              textAlign: "center",
              background: "linear-gradient(135deg, #ffffff 0%, #f8faff 100%)",
            }}
          >
            <Typography
              variant="h4"
              fontWeight={700}
              color="primary"
              gutterBottom
            >
              Why Partner With IONEC?
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              We are not just a vendor — we are your{" "}
              <strong>innovation partner</strong>.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              We understand that true business improvement requires more than
              just new software — it requires a shift in thinking. Our team of
              experts is passionate about applying the latest innovative
              technology to solve your toughest problems, giving you the
              competitive edge needed to define the next era of your industry.
            </Typography>
          </Card>
        </Container>
      </Box>
    </Container>
  );
}
